module.exports = __webpack_public_path__ + "img/arrow_down.a63e8373.svg";